import "./AdminTable.scss";
import PropTypes from "prop-types";
import { useTable } from "react-table";
import { useLocation } from "react-router-dom";

const AdminTable = ({ columns, data, id }) => {
  const location = useLocation();
  const tableInstance = useTable({
    columns,
    data,
  });
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    tableInstance;
  return (
    <table
      {...getTableProps()}
      style={{
        left: "0",
        right: "0",
        margin: "auto",
        width: "100%",
      }}
      id={id}
    >
      <thead>
        {headerGroups.map((headerGroup, i) => (
          <tr
            {...headerGroup.getHeaderGroupProps()}
            style={{ borderRadius: "20px" }}
            key={`tr-${i}`}
          >
            {headerGroup.headers.map((column, index) => (
              <th
                {...column.getHeaderProps()}
                style={{
                  fontSize: "18px",
                  color: "white",
                  backgroundColor: "#140d49",
                  fontWeight: "bold",
                  textAlign: "center",
                  padding: "10px",
                  minWidth: column.minWidth,
                  maxWidth: column.maxWidth,
                  width: column.width,
                }}
                key={index}
              >
                {column.render("Header")}
              </th>
            ))}
          </tr>
        ))}
      </thead>

      <tbody {...getTableBodyProps()}>
        {rows.map((row, i) => {
          prepareRow(row);
          return (
            <tr
              {...row.getRowProps()}
              key={`tr-${i}`}
              className={
                location.pathname.includes("new") ||
                location.pathname.includes("edit")
                  ? "display-center"
                  : ""
              }
            >
              {row.cells.map((cell, index) => {
                return (
                  <td
                    {...cell.getCellProps()}
                    style={{
                      padding: "10px",
                      borderTop: "solid 1px gray",
                      textAlign: "center",
                      color: "white",
                      backgroundColor: "#140d49",
                    }}
                    key={index}
                  >
                    {cell.render("Cell")}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
AdminTable.propTypes = {
  id: PropTypes.string.isRequired,
  columns: PropTypes.array.isRequired,
  data: PropTypes.array,
};

AdminTable.defaultProps = {
  data: [],
};

export default AdminTable;
